import {
  LinkButton,
  SubTitle as CommonSubTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React, { useEffect, FunctionComponent, useCallback } from 'react';

import { useSignUp } from '../../../common/hooks/useSignUp';
import { SignUpStep } from '../../../common/provider/SignUpContext';
import { SolutionType } from '../../../common/api/types';

export const SubTitle: FunctionComponent = () => {
  const { currentStep, selectedSolutionType } = useSignUp();
  const [subTitle, setSubTitle] = React.useState<React.ReactNode>();

  useEffect(() => {
    switch (currentStep) {
      case SignUpStep.settingUp:
        setSubTitle(
          "This usually takes a few seconds. If it's taking too long or you have questions, please reach out to"
        );
        break;
      case SignUpStep.setupFailed:
        setSubTitle(
          'We will email your login information to the address you provided. If you have questions please reach out to'
        );
        break;
      case SignUpStep.waitlisted:
        setSubTitle(
          `The selected region is currently unavailable. We have added you to our waitlist. A representative will reach out once it becomes available. If you have any questions, please reach out to support at`
        );
        break;
      case SignUpStep.contactAdmin:
        setSubTitle(
          `You are trying to sign up for an organization that already exists. Please reach out to the account administrator to receive access. If you used the incorrect organization name, go back and try again with a new name. If you have any questions, please reach out to support at`
        );
        break;
      case SignUpStep.setupSuccess:
        if (selectedSolutionType === SolutionType.API) {
          setSubTitle(
            'Please find the API URL and Key below to get started. If you require assistance getting started, click on the documentation link for a quick start guide'
          );
        } else {
          setSubTitle(
            'Click the button below to log in to your new account. If you have questions please reach out to'
          );
        }
        break;
    }
  }, [currentStep, selectedSolutionType]);

  const handleOnClick = useCallback(() => {
    const toEmail = 'mailto:support@getos1.com';
    const subject =
      'subject=(Choose One) Sign-up | Try-out APIs | Org tenant | App registration | App Submissions and publishing | API | Account information | Other';
    const body =
      'Company/OrganizationName: %0D%0A Your Name: %0D%0A Topic of concern and details: %0D%0A ';
    window.open(`${toEmail}?subject=${subject}&body=${body}`, '_blank');
  }, []);

  return (
    <div className="w-full mt-2">
      <CommonSubTitle>
        <span
          className="text-xs text-slate-700 font-light"
          data-testid={`${currentStep}-step-subtitle`}
        >
          {subTitle}
          {selectedSolutionType === SolutionType.APP ||
          (selectedSolutionType === SolutionType.API &&
            currentStep === SignUpStep.settingUp) ? (
            <>
              &nbsp;
              <LinkButton
                linkText="support@getos1.com"
                onClick={handleOnClick}
              />
              <span>.</span>
            </>
          ) : (
            <span>.</span>
          )}
        </span>
      </CommonSubTitle>
    </div>
  );
};
